import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';
export default {
  state() {
    return {
      token: null,
      refreshToken: null,
      userID: null,
      firstName: null,
      lastName: null,
      userName: null,
      requireChangePassword: null,
      lastLoginDateTime: null,
      isPartTime: null,
      personID: null,
      userUnseenNotifications: [],
      hasUnseenMessage: null,
    };
  },
  mutations,
  actions,
  getters,
};
